import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DeliveryZoneCustomerState } from '../reducers';

export const selectDeliveryZoneCustomerState = createFeatureSelector<DeliveryZoneCustomerState>('deliveryZoneCustomer');

export const selectDeliveryZoneCustomerLoading = createSelector(
  selectDeliveryZoneCustomerState,
  (state: DeliveryZoneCustomerState) => state.loading
);

export const selectDeliveryZoneCustomerEditMode = createSelector(
  selectDeliveryZoneCustomerState,
  (state: DeliveryZoneCustomerState) => state.editMode
);

export const selectDeliveryZoneCustomerIsEditing = createSelector(
  selectDeliveryZoneCustomerState,
  (state: DeliveryZoneCustomerState) => state.isEditing
);

export const selectDeliveryZoneCustomer = createSelector(
  selectDeliveryZoneCustomerState,
  (state: DeliveryZoneCustomerState) => state.deliveryZoneCustomer
);

export const selectDeliveryZoneCustomerList = createSelector(
  selectDeliveryZoneCustomerState,
  (state: DeliveryZoneCustomerState) => state.deliveryZoneCustomerList
);

export const selectDeliveryZoneCustomerForm = createSelector(
  selectDeliveryZoneCustomerState,
  (state: DeliveryZoneCustomerState) => state.deliveryZoneCustomerForm
);

export const selectDeliveryZoneCustomerError = createSelector(
  selectDeliveryZoneCustomerState,
  (state: DeliveryZoneCustomerState) => state.error
);
